import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent, cueCheckCircle, cueClose } from '@cue/ui/icons';
import { translation } from '@cue/translations';

@Component({
  selector: 'assist-error-notification',
  imports: [IconComponent],
  templateUrl: './error-notification.component.html',
  styleUrl: './error-notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorNotificationComponent {
  title = input<string>('');
  text = input<string>('');

  ICONS = {
    cueClose,
  };
  protected readonly translation = translation;
}
